import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { apiTokenRequest } from "../config/authConfig";
import { callMsGraph } from "../services/graphService";
import { GraphUserData } from "../types/auth.types";
import { Card, Table, Alert, Spinner } from "react-bootstrap";
import { callBackend } from "../services/backendService";

const ProfileContent: React.FC = () => {
  const { instance, accounts } = useMsal();
  const [graphData, setGraphData] = useState<GraphUserData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const activeAccount = accounts[0];
    if (!activeAccount) {
      setError("No se encontró una cuenta activa.");
      setLoading(false);
      return;
    }

    const fetchGraphData = async () => {
      try {
        const response = await instance.acquireTokenSilent({
          ...apiTokenRequest,
          account: activeAccount,
        });
        const data = await callBackend(response.accessToken);
        setGraphData(data);
      } catch (err) {
        console.error("Error al obtener datos del perfil:", err);
        setError("Error al obtener datos del perfil. Intente nuevamente.");
      } finally {
        setLoading(false);
      }
    };

    fetchGraphData();
  }, [instance, accounts]);

  if (loading) {
    return (
      <div className="loading-spinner">
        <Spinner animation="border" role="status">
          <span className="visually-hidden">Cargando...</span>
        </Spinner>
      </div>
    );
  }

  if (error) {
    return (
      <Alert variant="danger" className="error-message">
        {error}
      </Alert>
    );
  }

  if (!graphData) {
    return (
      <Alert variant="info">No se pudieron cargar los datos del perfil</Alert>
    );
  }

  return (
    <Card className="profile-card">
      <Card.Header>
        <Card.Title className="mb-0">
          <i className="fas fa-user me-2"></i>
          Información del Perfil
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <Table striped bordered hover>
          <tbody>
            <tr>
              <td>
                <strong>Nombre de Usuario</strong>
              </td>
              <td>{graphData.username}</td>
            </tr>
            <tr>
              <td>
                <strong>Nombre</strong>
              </td>
              <td>{graphData.name}</td>
            </tr>
            <tr>
              <td>
                <strong>ID de Usuario</strong>
              </td>
              <td>{graphData.userId}</td>
            </tr>
            <tr>
              <td>
                <strong>ID de Tenant</strong>
              </td>
              <td>{graphData.tenantId}</td>
            </tr>
            <tr>
              <td>
                <strong>Emitido en</strong>
              </td>
              <td>{new Date(graphData.issuedAt).toLocaleString()}</td>
            </tr>
            <tr>
              <td>
                <strong>Expira en</strong>
              </td>
              <td>{new Date(graphData.expiresAt).toLocaleString()}</td>
            </tr>
          </tbody>
        </Table>
      </Card.Body>
    </Card>
  );
};

export default ProfileContent;
